function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M386.204 247.742C407.71 226.734 421.161 197.524 421.161 165.161C421.161 107.074 377.943 59.3181 322.065 51.2174V0H256V49.5481H189.935V0H123.87V49.5481H90.8389V115.613H123.871V379.871H90.8389V445.936H123.871V512.001H189.936V445.936H256.001V512.001H322.066V444.267C377.945 436.166 421.162 388.41 421.162 330.323C421.161 297.96 407.71 268.75 386.204 247.742V247.742ZM355.096 165.161C355.096 192.484 332.871 214.709 305.548 214.709H189.935V115.613H305.548C332.871 115.613 355.096 137.838 355.096 165.161ZM305.548 379.87H189.935V280.774H305.548C332.871 280.774 355.096 302.999 355.096 330.322C355.096 357.645 332.871 379.87 305.548 379.87V379.87Z",
  fill: "#F7931A"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  fill: "white"
}));

function SvgBitcoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 412 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.4915cebd.svg";
export { ForwardRef as ReactComponent };